module.exports = __webpack_public_path__ + "img/photo_none.3aac4cee.png";